import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {
  IconButton,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import set from "lodash/fp/set";
import { Fragment } from "react";

type Props<keyProp extends string, valueProp extends string> = {
  keyProp: keyProp;
  keyPlaceholder?: string;
  valueProp: valueProp;
  valuePlaceholder?: string;
  value: {
    [key in keyProp | valueProp]: string;
  }[],
  onChange: (newValue: {
    [key in keyProp | valueProp]: string;
  }[]) => void;
  disabled?: boolean;
}

function KeyValueList<keyProp extends string, valueProp extends string>({
  keyProp,
  keyPlaceholder,
  valueProp,
  valuePlaceholder,
  value,
  onChange,
  disabled,
}: Props<keyProp, valueProp>) {
  const rows = value.length > 0 ? value : [{ [keyProp]: "", [valueProp]: "" }] as typeof value

  return <Grid container sx={{ mt: 2 }}>
    {rows.map((item, index) => <Fragment key={index}>
      <Grid size={4}>
        <TextField
          fullWidth
          size="small"
          value={item[keyProp]}
          onChange={(e) => onChange(set(`${index}.${keyProp}`, e.target.value, rows))}
          disabled={disabled}
          placeholder={keyPlaceholder}
          error={!!item[valueProp] && !item[keyProp]}
        />
      </Grid>
      <Grid size={7}>
        <TextField
          fullWidth
          size="small"
          value={item[valueProp]}
          placeholder={valuePlaceholder}
          onChange={(e) => onChange(set(`${index}.${valueProp}`, e.target.value, rows))}
          disabled={disabled}
          error={!!item[keyProp] && !item[valueProp]}
        />
      </Grid>
      <Grid size={1}>
       <IconButton
          onClick={() => onChange(value.filter(i => i !== item))}
          disabled={disabled || (index === 0 && ! item[keyProp] && !item[valueProp])}
        >
          <RemoveCircleOutlineIcon />
        </IconButton>
      </Grid>
    </Fragment>)}

    <Grid size={11}></Grid>
    <Grid size={1}>
      <IconButton
        onClick={() => onChange([...rows, { [keyProp]: "", [valueProp]: "" } as any])}
        disabled={disabled}
      >
        <AddCircleOutlineIcon />
      </IconButton>
    </Grid>
  </Grid>
}

export default KeyValueList;
